import React from "react";
import { Target } from "lucide-react";
import { GoalsView } from "../components/goals/GoalsView";

export default function GoalsPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6" data-testid="goals-page">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-[#00305E] flex items-center justify-center">
          <Target className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#00305E]">Goals</h1>
          <p className="text-sm text-slate-500">Student IEP goals, objectives, progress logs and reports.</p>
        </div>
      </div>
      <GoalsView />
    </div>
  );
}
